export default () => {
    const filter_sections = document.querySelectorAll('.js-archive-filters');
    if (filter_sections) {
        filter_sections.forEach(element => {
            const filter_toggle = element.querySelector('.js-filters-toggle');
            const filter_list = element.querySelector('.js-filters-list');
            if (filter_toggle) {
                const filter_label = filter_toggle.querySelector('.js-label');
                filter_toggle.addEventListener('click', toggle => {
                    document.body.classList.toggle('filter-open');
                    element.classList.toggle('is-active');
                    toggle.currentTarget.classList.toggle('is-active');
                    filter_label.innerText = filter_label.dataset.labelClose;
                    if (element.classList.contains('is-active')) {
                        filter_label.innerText = filter_label.dataset.labelClose;
                        filter_list.style.maxHeight = filter_list.scrollHeight + 'px';
                    } else {
                        filter_label.innerText = filter_label.dataset.labelOpen;
                        filter_list.style.maxHeight = 0;
                    }
                })
            }
        });
    }

    const filter = document.querySelector('.js-filters');
    const productList = document.querySelectorAll('.js-archive-section-filters');
    if (filter && productList) {
        filter.addEventListener('change', () => { onFilterChange(filter, productList); });
        setQueryParamsToFilters();
    }

    const filterBlog = document.querySelector('.js-filters-blog');
    if (filterBlog) {
        filterBlog.addEventListener('change', () => { onFilterBlogChange(filterBlog); });
    }
}

const onFilterBlogChange = (filterEl) => {
    let activeFilters = Array.from(filterEl.querySelectorAll('input'))
        .filter(input => input.checked)
        .reduce((filters, filterEl) => {
            let { id } = filterEl;
            filters.push(id);
            return filters;
        }, []);

    const archiveSection = document.querySelector('.SectionBlock--Blog');
    if (archiveSection) {
        archiveSection.querySelector('.Archive').classList.add('is-filtering');

        fetch(`${window.location.origin}/wp-json/api/filter-posts?categories=${activeFilters && activeFilters.join()}`)
        .then(res => res.json())
        .then(body => {
            archiveSection.querySelector('.Archive__Wrapper').innerHTML = JSON.parse(body);
            archiveSection.querySelector('.Archive').classList.remove('is-filtering');
        })
    }

    
}

const onFilterChange = (filterEl, productList) => {
    let activeFilters = getActiveFilters(filterEl);
    addQueryParams(activeFilters);
    let emptyFilters = Object.keys(activeFilters).length == 0;
    handleArchive( productList, emptyFilters, activeFilters );
}

const getActiveFilters = (filterEl) => {
    return Array.from(filterEl.querySelectorAll('input'))
        .filter(input => input.checked)
        .reduce((filters, filterEl) => {
            let { name, value } = filterEl;
            filters[name] = filters[name] == undefined ? [value] : [...filters[name], value];
            return filters;
        }, {});
}

const handleArchive = (productList, emptyFilters, activeFilters) => {
    if(!(Object.entries(activeFilters).length > 0)) {
        return;
    }
    productList.forEach(productCat => {
        let products = productCat.querySelectorAll('.js-filter-product');
        let productCount = 0;
        products.forEach(product => {
            if (emptyFilters) {
                changeProductVisibility(product, 'show', 500);
                productCount++;
                return;
            }
            let productAttrs = Object.fromEntries(Object.entries(product.dataset).map(
                ([key, value]) => [key, value.split('|')]
            ));

            let matchAllFilters = Object.entries(activeFilters).every( ([key, value]) => {
                    return productAttrs[key] != undefined && productAttrs[key].every( productAttr => {
                        return value.includes(productAttr)
                    });
            });         
            
            changeProductVisibility(product, matchAllFilters ? 'show' : 'hide', 500);
            if (matchAllFilters) {
                productCount++;
            }
        });

        let transition = (productCount > 0) ? 'is-appearing' : 'is-disappearing';
        let display = (productCount > 0) ? '' : 'none';

        if (productCat.style.display !== display) {
            productCat.classList.add(transition);
            productCat.style.display = display;
            setTimeout(() => {
                productCat.classList.remove(transition);
            }, 500);
        }
    });
}

const addQueryParams = (activeFilters) => {
    const url = new URL(window.location.href);
    if (!Array.isArray(activeFilters)) {
        activeFilters = Object.entries(activeFilters);
    }

    url.search = '';
    if(activeFilters.length > 0) {
        let queryParams = activeFilters.reduce((queryParams, [key, value]) => {
            queryParams[key] = value.join(',');

            return queryParams;
        }, {});
        Object.entries(queryParams).forEach(params => {
            const [key, value] = params;
            if (value) {
                url.searchParams.set(key, value);
            }
        });
    }
    window.history.replaceState(null, null, url); // or pushState
}

const setQueryParamsToFilters = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    const filter = document.querySelector('.js-filters');
    const productList = document.querySelectorAll('.js-archive-section-filters');
    if (filter) {
        const filters = filter.querySelectorAll('input');
        filters.forEach(filter => {
            const { name, value } = filter;
            if (params[name]) {
                const values = params[name].split(',');
                if (values.includes(value)) {
                    filter.checked = true;
                }
            }
        });
    }

    let activeFilters = getActiveFilters(filter);
    let emptyFilters = Object.keys(activeFilters).length == 0;
    handleArchive( productList, emptyFilters, activeFilters );
}

const changeProductVisibility = (element, status, timeout) => {
    let transition = (status == 'show') ? 'is-appearing' : 'is-disappearing';

    if (element.dataset.filters !== status) {
        element.classList.add(transition);
        element.dataset.filters = status;
        element.style.display = (status == 'show') ? '' : 'none';
        setTimeout(() => {
            element.classList.remove(transition);
        }, timeout);
    }
}